module.exports = __webpack_public_path__ + "static/img/bg.e628ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.png
// module id = yEeP
// module chunks = 1